import { api } from '@/services';
import type {
  IntegracaoRTCAcaoResponse,
  IntegracaoRTCStatusResponse,
  SalvarIntegracaoRTCPayload,
} from '../types';

const BASE = 'TurboPro/IntegracoesRTC';

export const fetchIntegracaoRTCStatus = (cnpjContribuinte: string) =>
  api.get<IntegracaoRTCStatusResponse>(
    `${BASE}/Status?cnpjContribuinte=${encodeURIComponent(cnpjContribuinte)}`
  );

export const salvarIntegracaoRTC = (payload: SalvarIntegracaoRTCPayload) =>
  api.post<IntegracaoRTCAcaoResponse, SalvarIntegracaoRTCPayload>(`${BASE}/Salvar`, payload);

export const testarConexaoIntegracaoRTC = (cnpjContribuinte: string) =>
  api.post<IntegracaoRTCAcaoResponse, { CNPJ_Contribuinte: string }>(`${BASE}/TestarConexao`, {
    CNPJ_Contribuinte: cnpjContribuinte,
  });
